import { render, staticRenderFns } from "./DocumentWithSectionsHistorical.vue?vue&type=template&id=a7bcee7a&scoped=true"
import script from "./DocumentWithSectionsHistorical.vue?vue&type=script&lang=js"
export * from "./DocumentWithSectionsHistorical.vue?vue&type=script&lang=js"
import style0 from "./DocumentWithSectionsHistorical.vue?vue&type=style&index=0&id=a7bcee7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bcee7a",
  null
  
)

export default component.exports